import axios from "axios";

export default axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? `${process.env.VUE_APP_API_SERVER}/api/v1/`
      : "/api/v1/"
});
